import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=24bfc2ee&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"
import style0 from "./highlight.vue?vue&type=style&index=0&id=24bfc2ee&prod&scoped=true&lang=css"
import style1 from "./highlight.vue?vue&type=style&index=1&id=24bfc2ee&prod&lang=css"
import style2 from "./highlight.vue?vue&type=style&index=2&id=24bfc2ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bfc2ee",
  null
  
)

export default component.exports